import React, { Dispatch, SetStateAction, useState } from "react";
import { ModalTermStyled } from "./styles";
import { Modal } from "../Modal";

type iModalTerm = {
  showModalTerm: boolean;
  setShowModalTerm: Dispatch<SetStateAction<boolean>>;
};

export const ModalTerm = ({ showModalTerm, setShowModalTerm }: iModalTerm) => {
  return (
    <ModalTermStyled>
      {showModalTerm && (
        <Modal showModal={setShowModalTerm}>
          <div className="modal">
            <div className="modal-content">
              <h1>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA MUNGANGO</h1>

              <h2>1. Aspectos Gerais</h2>
              <p>
                Estes termos e condições de uso norteiam a utilização e o acesso
                da plataforma virtual MUNGANGO, estabelecida no Brasil, na qual
                estão inclusos sites, notificações por e-mail ou SMS,
                propagandas, aplicativos, bem como quaisquer vídeos, áudios,
                imagens, links, informações que sejam exibidos. Ao acessar ou
                usar nossos serviços, você concorda em cumprir os termos abaixo
                dispostos.
              </p>

              <h2>2. Serviços</h2>
              <p>
                Estes termos e condições de uso são adotados com o objetivo de
                regulamentar a utilização dos serviços ofertados pela plataforma
                MUNGANGO aos usuários. Dentre os serviços ofertados, pode-se
                destacar: a publicação de conteúdo, uma vez que os usuários
                podem publicar textos, imagens e outros tipos de mídia em suas
                contas; interação social; mensagens diretas; notificações e
                alertas; personalização de perfil e ferramentas de busca. Em se
                tratando da disponibilidade do serviço, ressalta-se que, apesar
                do esforço para que este seja mantido numa escala de 24/7, não é
                garantido que ele estará livre de interrupções ou erros. Logo, o
                serviço poderá ser suspenso temporariamente para manutenção,
                atualização ou motivos de força maior. Ademais, é válido
                salientar que o serviço também pode ser limitado por motivos
                técnicos, a exemplo de problemas de conectividade ou manutenção.
                Contudo, não será responsabilidade da plataforma/rede social
                qualquer tipo de indisponibilidade ou interrupção de acesso que
                possa ocorrer.
              </p>

              <h2>
                3. Informações e Restrições sobre a Propriedade Intelectual e
                Direitos Autorais
              </h2>
              <p>
                Diante do aceite destes termos e condições de uso, o usuário
                também concorda que o conteúdo exposto na interface é protegido
                pela legislação e direitos de propriedade industrial e
                intelectual, sendo de domínio da plataforma. Sendo assim, o
                usuário não poderá modificar, remover, copiar, distribuir,
                revender, exibir, transmitir, dentre outros, qualquer informação
                ou documento da plataforma ou ainda exploraros seus serviços, a
                não ser pela forma permitida pela MUNGANGO. Caso assim o faça,
                poderá incorrer na violação de leis aplicáveis, o que pode gerar
                penalidades civis e/ou criminais. Além do referido acima, o
                usuário também não deve usar a plataforma de maneira
                inautêntica, a fim de fraudar, inserir declarações falsas,
                participar de publicidade falsa, dentre outros, ou danificar,
                decompilar, criar engenharia reversa ou desmontar os serviços,
                fazer coleta de dados, scraping, de qualquer informação ou
                material da plataforma, exceto conforme permitido pela
                legislação aplicável. Ademais, destaca-se que todos os direitos,
                títulos e interesses relacionados ao serviço e seu conteúdo
                pertencem à MUNGANGO ou seus licenciadores, logo, você não
                adquire nenhum direito de propriedade intelectual ao utilizá-la.
                Diante disso, ao utilizar a referida rede social, você concede à
                plataforma uma licença não exclusiva, global, livre de royalties
                e sublicenciável para usar, reproduzir, modificar e distribuir o
                conteúdo que você publica no serviço para fins operacionais,
                funcionais e promocionais da plataforma.
              </p>

              <h2>4. Modificação</h2>
              <p>
                A plataforma poderá alterar estes termos e condições a qualquer
                momento, entretanto, caso isso ocorra, esses serão atualizados,
                a fim de que os usuários tenham ciência das modificações
                realizadas. Destaca-se que a versão responsável pela
                regulamentação das relações geradas na plataforma será a última
                lançada.
              </p>

              <h2>5. Conta de Usuário</h2>
              <p>
                O usuário, diante da criação de sua conta na plataforma
                MUNGANGO, manifesta sua vontade inequívoca na aceitação destes
                termos e condições de uso. Além disso, ele permite o uso de
                cookies em todas as atividades realizadas pela plataforma.
                Ademais, destaca-se que o uso da conta nesta plataforma é
                pessoal e intransferível, não autorizando a cessão de dados de
                acesso. Havendo perda, esquecimento ou defraudação desses, cabe
                ao usuário informar acerca do ocorrido por meio da opção
                “esqueci minha senha” ou por meio do suporte disponível na
                plataforma.A administração da conta será de responsabilidade da
                plataforma ou de pessoa designada por ela.
              </p>

              <h2>6. Uso dos Serviços</h2>
              <p>
                Para utilização dos serviços anteriormente descritos, o usuário
                deverá ter capacidade jurídica para atos civis, bem como deverá
                fornecer as informações solicitadas no cadastro, situação em que
                terá total responsabilidade pela veracidade de seus dados, os
                quais, poderão ser verificados a qualquer momento pela
                plataforma. No caso de fornecimento de informações falsas,
                incorretas ou não confirmadas, bem como diante da negativa de
                sua correção ou do envio da documentação necessária para esse
                ato, pode a plataforma optar pela conclusão ou não do cadastro,
                como também pelo impedimento do uso dos serviços virtuais, até
                que entenda que os vícios foram sanados. Além de, a critério da
                própria plataforma, ter o direito de cancelar cadastros
                realizados ou inviabilizar novos cadastros, ante a detecção de
                falhas e vícios que, em sua observação, sejam graves ou
                tentativas de violar as regras destes termos. Ademais, a
                MUNGANGO reserva-se no direito de revisar, moderar ou remover
                qualquer conteúdo que considere uma violação aos referidos
                termos ou que possa prejudicar a experiência do usuário. Também
                é válido ressaltar que você é o responsável pelo conteúdo que
                publica e pelas consequências advindas da sua publicação, sendo
                assim a referida rede social não endossa, bem como não assume
                qualquer responsabilidade pelo conteúdo publicado pelos
                usuários.
              </p>

              <h2>7. Mensagem de Texto</h2>
              <p>
                Diante da criação da conta, você também concorda com o
                recebimento de mensagens de texto curtas e informativas...
              </p>

              <h2>8. Conteúdos</h2>
              <p>
                O referido serviço de tecnologia, por meio de sua plataforma,
                também poderá apresentar informações publicitárias ou mercantis,
                a serviço próprio ou de terceiros. Destaca-se que a plataforma
                não possui responsabilidade ante a prestação de
                serviços/produtos que sejam de terceiros. Logo, é de
                responsabilidade dos usuários, que deverão verificar e conhecer
                os serviços oferecidos por terceiros, o acesso aos sites
                remetidos via publicidade. Ademais, poderá a plataforma
                MUNGANGO, a critério próprio, consentir que qualquer pessoa
                disponibilize, carregue ou publique informações de aspecto
                textual ou audiovisual, inclusive comentários e feedbacks
                referentes aos serviços, solicitação de suporte e participação
                em concursos e promoções. Ressalta-se mais uma vez que qualquer
                conteúdo fornecido pelo usuário continua em sua propriedade,
                entretanto ao disponibilizá-lo na plataforma, é concedida pelo
                usuário uma licença, livre de royalties, irrevogável e que
                permite o uso, de variadas formas, a fim de dar à referida rede
                social o direito de explorar o conteúdo fornecido pelo usuário
                por todos os meios e canais de distribuição conhecidos ou que
                vierem a ser criados, sem a necessidade de aviso prévio. Diante
                disso, ao aceitar os referidos termos, o usuário assegura sua
                única e exclusiva propriedade acerca de todos os conteúdos
                disponibilizados ou, ainda, que possui total direito,
                consentimento, licença e liberações exigidas para concedê-los,
                Além disso, é assegurado ao usuário que a referida concessão não
                ferirá ou infringirá as normas e legislações aplicáveis,
                tampouco, violarão os direitos de publicidade ou privacidade.
                Outrossim, exige-se do usuário que, ao concordar com os
                referidos termos, não serão fornecidos conteúdos de cunho
                ofensivo, obsceno, pornográfico ou contrário à lei, sendo desde
                já avisado que o conteúdo poderá ser retirado, sem aviso prévio
                e por qualquer motivo, pela plataforma.Em se tratando do uso da
                plataforma, ressalta-se que o usuário é o responsável pela
                aquisição dos dispositivos necessários para o seu acesso. Nessa
                situação, esclarece-se que o funcionamento do aplicativo e de
                seus serviços não é garantido em qualquer aparelho. Além disso,
                o serviço pode ser comprometido ante a falhas na rede de
                internet ou de comunicação. O usuário também será responsável
                pelas taxas e encargos da rede de dados e mensagens.
              </p>

              <h2>9. Deveres da Plataforma</h2>
              <p>
                A plataforma se compromete a utilizar os dados e as informações
                para a finalidade necessária, conforme disposto nos referidos
                termos. Ademais, é dever da plataforma proteger a
                confidencialidade das informações e dados cadastrais e até mesmo
                bancários dos usuários, caso estes sejam fornecidos pelos
                usuários, entretanto, destaca-se que caso o sistema de segurança
                seja invadido, não serão de responsabilidade da plataforma os
                prejuízos gerados. Sendo assim, ela não será responsável por
                danos, como danos morais, patrimoniais, emergentes, indiretos,
                dentre outros, decorrentes do uso dos serviços pelo
                usuário/consumidor e das ações relacionados a ele
              </p>

              <h2>10. Legislação Aplicável e Foro</h2>
              <p>
                Por estarem certas e ajustadas, as partes elegem o foro da
                comarca de Itabaiana/SE como competente para dirimir qualquer
                controvérsia do referido termo.
              </p>
            </div>
          </div>
        </Modal>
      )}
    </ModalTermStyled>
  );
};
